/* eslint-disable import/prefer-default-export */
export var EVENT_SUPPORT_NEEDED = "mba__support_needed";
export var EVENT_PRIVATE_ENQUIRY = "mba__private_enquiry_requested";
export var EVENT_MORE_PRODUCT_INFORMATION = "mba__more_product_information_requested";